import { useQuery } from '@tanstack/react-query';
import { canadianPayoutCopy, type CanadianPayoutCopy } from '@evi/shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/store/auth';
import styles from './CanadianPayoutNote.module.css';

export function CanadianPayoutExplanation({ copy }: { copy: CanadianPayoutCopy }) {
  return <aside className={styles.note} aria-label={copy.subject}>
    <h3 className={styles.title}>{copy.subject}</h3>
    {copy.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
  </aside>;
}

export function CanadianPayoutNote({ locationId }: { locationId?: string }) {
  const user = useAuthStore(state => state.user);
  const query = useQuery({ queryKey: ['payout-onboarding', user?._id, user?.tenant_id, user?.role, user?.template, locationId], enabled: !!user,
    queryFn: async () => (await api.get('me/payout-onboarding', {
      ...(locationId ? { searchParams: { location_id: locationId } } : {}),
    }).json<{ data: { eligible: boolean; locale: string } }>()).data, staleTime: 60_000,
  });
  if (!query.data?.eligible) return null;
  return <CanadianPayoutExplanation copy={canadianPayoutCopy(query.data.locale)} />;
}
